import React from "react";
import { QuestionMark } from "@mui/icons-material";
import { motion } from "framer-motion";
import SlideBox from "../versatile/SlideBox";
import AboutCardMatrix from "../AboutCardMatrix";

const General = () => {
  const data = [
    {
      headline: "Data",
      icon: <QuestionMark fontSize="large" />,
      paragraphs: [
        "Vision Tools is a personal project to highligt my work progress and projects.",
        "Will provide creative metrics and tools.",
        "In this neon design.",
      ],
    },
  ];

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8 } },
  };

  const texts = [
  `> Building toward a career in data science and analytics.

> Currently working through real-world datasets and competitions on Kaggle.

> Documenting the process — feature engineering, model building, and lessons learned.

> Projects and notebooks coming soon.`,
];

  return (
    <motion.div
      style={{
        gridColumn: "3 / span 12",
        gridRow: "5 / span 14",
        padding: window.innerWidth < 1600 && window.innerHeight < 900 ? "0.5rem" : "2rem",
        transition: "all 0.3s ease",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
      variants={fadeIn}
      initial="hidden"
      animate="visible"
    >
      <div style={{ flex: 1, marginRight: "1rem" }}>
      <SlideBox
        data={data}
        
      />
      </div>
      <div style={{ flex: 2 }}>
        <AboutCardMatrix texts={texts} speed={100} />
      </div>
    </motion.div>
  );
};

export default General;
